var map = {
	"./22/ETH_USD_70.json": 56352,
	"./23/ETH_USD_70.json": 56645,
	"./24/ETH_USD_70.json": 1794,
	"./26/ETH_USD_70.json": 35444,
	"./28/ETH_USD_70.json": 55110,
	"./29/ETH_USD_70.json": 28435,
	"./30/ETH_USD_70.json": 13225,
	"./31/ETH_USD_70.json": 7364,
	"./32/ETH_USD_70.json": 51775,
	"./33/ETH_USD_70.json": 81650,
	"./34/ETH_USD_70.json": 70229,
	"./35/ETH_USD_70.json": 52592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64543;